import React, {Component} from "react";
import "./index.css";
import { withRouter } from "react-router-dom";
import ClubRoutes from "./routes/ClubRoutes";
import ShopRoutes from "./routes/ShopRoutes";
import ComRoutes from "./routes/ComRoutes";


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
        <div
            style={{
                width: '100dvw',
                height: '100dvh',
                overflow: 'hidden',
            }}
        >
            <DomainRouter/>
        </div>
    );
  }
}

App = withRouter(App);

export default App;

const DomainRouter = () => {
    const host = window.location.hostname;

    if (host.includes("schmodel.club")) {
        return <ClubRoutes />;
    }
    if (host.includes("schmodel.shop")) {
        return <ShopRoutes />;
    }
    return <ComRoutes />;
}
